<!--
 * @Descripttion: 劳务税金
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="asp-order box-flex-column">
    <BaseTabs @click="setPageType" v-model="pageType">
      <BaseTabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      ></BaseTabPane>
    </BaseTabs>

    <BaseLayoutFlexContent>
      <AverageOrderList
        style="height: 100%"
        v-if="pageType === '2'"
      ></AverageOrderList>
      <ContinuousOrderList
        style="height: 100%"
        v-if="pageType === '3'"
      ></ContinuousOrderList>
    </BaseLayoutFlexContent>
  </div>
</template>

<script lang="tsx" setup>
import AverageOrderList from '../components/average-order-list.vue';
import ContinuousOrderList from '../components/continuous-order-list.vue';
import { computed, ref } from 'vue';
import { BaseTabs, BaseTabPane, BaseLayoutFlexContent } from 'xrk-components';
import { useRoute, useRouter } from 'vue-router';
import { resource } from '@/utils';
const route = useRoute();
const router = useRouter();

const tabs = computed(() => {
  return [
    resource.checkPermission('一般劳务') && {
      label: '一般劳务',
      value: '2'
    },
    resource.checkPermission('连续劳务') && {
      label: '连续劳务',
      value: '3'
    }
  ].filter(Boolean);
});

const pageType = ref(tabs.value[0].value);
const setPageType = () => {
  if (route.query.orderNo) {
    // 清除路由上的查询参数
    router.replace({
      query: { force: Date.now() }
    });
  }
};
</script>
<style lang="scss"></style>
